<script lang="ts">
  import { createEventDispatcher, onDestroy, onMount } from 'svelte'
  import { getCategorizations } from '../../persistence'
  import { db } from '../../db'
  import { syncCount } from '../../stores'

  const dispatch = createEventDispatcher()
  const controller = new AbortController()

  const fetchCategorizations = async () => {
    const { categorizations = [], error } = await getCategorizations(true, controller)

    if (error || controller.signal.aborted) return false

    await db.categorizations.bulkPut(categorizations)

    return !controller.signal.aborted
  }

  onDestroy(() => controller.abort())

  onMount(async () => {
    try {
      syncCount.update(count => count + 1)
      if (await fetchCategorizations()) dispatch('success')
    } finally {
      syncCount.update(count => count - 1)
    }
  })
</script>
